import { BROADCAST_CHANNEL_NAME } from './BroadcastChannel.constants';
const transmitter = new BroadcastChannel(BROADCAST_CHANNEL_NAME);
export const broadcastMessage = (m) => {
    transmitter.postMessage(m);
};
